export default function (props) {
  return (
    <div className="h-9 w-9 p-1 text-center rounded-md text-gray-800 bg-gray-100 hover:bg-gray-800 hover:text-gray-100">
      {props.children}
    </div>
  );
}
